import {Component, ViewEncapsulation} from "@angular/core";
import {CurrentUser} from "../../auth/current-user";
import {AuthService} from "../../auth/auth.service";

@Component({
    selector: 'logged-in-user-widget',
    templateUrl: './logged-in-user-widget.component.html',
    styleUrls: ['./logged-in-user-widget.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LoggedInUserWidgetComponent  {

    /**
     * LoggedInUserWidgetComponent Constructor.
     */
    constructor(public currentUser: CurrentUser, public auth: AuthService) {}
}



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/app/shared/logged-in-user-widget/logged-in-user-widget.component.ts